import { apiClient } from "./apiClient";
import { IHomeDashboardResponse } from "../features/home/Interfaces/IHomeInterface";

export async function getHomeDashboardInfo(): Promise<IHomeDashboardResponse> {
  const response = await apiClient.get<IHomeDashboardResponse>("/home/info");
  return response.data;
}
